module.exports = __webpack_public_path__ + "img/metal_ar@2x.b684d4cf.png";